var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentcolor",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 18.5h11v-1.53H6zm0-7.647h3.143v4.588h4.714v-4.588H17L11.5 5.5z"
})));
export default SvgUpload;